export enum PaymentMethods {
    CreditCard = 'credit_card',
    BankAch = 'bank_ach',
    BankWire = 'bank_wire',
    Cryptocurrency = 'cryptocurrency',
    MailACheck = 'mail_a_check',
    VinovestFunds = 'vinovest_funds',
    Other = 'other' // for any other payment methods not explicitly defined
}
